import React from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import LoadingAnimation from 'components/loading-animation';
import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';

export const Loading = makeUclComponent(LoadingAnimation).withConfig<{ $windowHeight?: number }>(
  ({ $windowHeight }) => ({
    ...($windowHeight && { minHeight: $windowHeight - 107 }),
  })
);

const styles = StyleSheet.create({
  spinnerContainer: {
    height: '100%',
    justifyContent: 'center',
  },
});

export const SpinnerContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.spinnerContainer, style] });
